import React, { useCallback, useRef } from 'react';
import { connect } from 'react-redux';
import { CardPicker } from '@americanexpress/aqx-components';
import useCardSelectorItemClickDtm from 'src/universal/hooks/useCardSelectorItemClickDtm';
import { buildCompareCtaDtm } from 'src/universal/utils/cardSelectorHelper';

import {
  getSelectedCompareCards,
  dispatchAddCardsToCompare,
  getCardSelectorData
} from 'src/universal/redux/compareCardsTray';
import { getCardSelectorCards } from 'page_modules/compare/redux';
import {
  sendDTMClickEvent,
  mapUrlWithDtmLinkQuery
} from 'service_modules/models/dtm-tagging';

import styles from './__styles__/index.scss?modules';

const CardSelector = ({
  selectorData,
  addCards,
  categoriesOfCards,
  selectedCards,
  toggle
}) => {
  useCardSelectorItemClickDtm(
    styles.cardSelector,
    selectorData?.cardItemDtm,
    categoriesOfCards
  );
  const processingBackClick = useRef(false);

  /*
  US5116490: why the special treatments inside the following 2 cta handlers?
  (1) This CardSelector is triggered by the CardTray component on VAC page.
  (2) The card placeholder (with the "plus icon") on the CardTray invites user to click to
      switch to a new card.  Hence we need to back-support this feature until the entire
      user-flow gets formally redesigned/changed in the future.
  (3) There was an attempt of revising AQX's CordSelector to support a flexible and
      multiple usages but was rejected by the AQX staffs.   
  */

  const onCtaBackClick = useCallback(
    () => {
      const ctaSelector = '[data-qe-id=vacCardSelector_card-picker-compare-button]';
      const ctaTarget = document.querySelector(
        `.${styles.cardSelector} ${ctaSelector}`
      );
      if (typeof ctaTarget?.click === 'function') {
        processingBackClick.current = true;
        ctaTarget.click();
      }
    },
    [selectorData]
  );

  const onCtaCompareClick = useCallback(
    shortNames => {
      addCards(shortNames);
      if (processingBackClick.current) {
        sendDTMClickEvent(selectorData?.ctaBackDtm);
        toggle();
      } else {
        const dtmObj = buildCompareCtaDtm(
          shortNames,
          selectorData?.ctaCompareDtm,
          categoriesOfCards
        );
        sendDTMClickEvent(dtmObj);
        const url = mapUrlWithDtmLinkQuery(
          selectorData?.ctaCompareUrl,
          selectorData?.ctaCompareDtm
        );
        window.location.href = url;
      }
    },
    [selectorData]
  );

  return (
    <div className={styles.cardSelector}>
      <CardPicker
        qeId="vacCardSelector"
        selectedCards={selectedCards}
        title={selectorData?.title}
        backButtonText={selectorData?.ctaBackText}
        compareButtonText={selectorData.ctaCompareText}
        backButtonOnClick={onCtaBackClick}
        compareOnClick={onCtaCompareClick}
        categoriesOfCards={categoriesOfCards}
      />
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  addCards: shortNames => dispatchAddCardsToCompare(dispatch, { shortNames })
});
const mapStateToProps = state => ({
  selectedCards: getSelectedCompareCards(state),
  categoriesOfCards: getCardSelectorCards(state),
  selectorData: getCardSelectorData(state)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CardSelector);
